import { SnackBarService } from '@erbfactors/shared-ui';
import { tap } from 'rxjs/operators';
import { Injectable } from '@angular/core';
import { CanActivate, Router } from '@angular/router';
import { Store } from '@ngrx/store';
import { is_administrator } from './../store/auth.selectors';

@Injectable()
export class AdministratorGuard implements CanActivate {
  constructor(
    private store: Store,
    private router: Router,
    private snackbar: SnackBarService
  ) {}
  canActivate() {
    return this.store.select(is_administrator).pipe(
      tap((bool) => {
        if (!bool) {
          this.snackbar.openSnackbar({
            message: 'Δεν έχετε πρόσβαση στην σελίδα που επιλέξατε.',
            cssClass: ['snackbar-error'],
          });
          this.router.navigate(['/dashboard']);
        }
      })
    );
  }
}
